import { area } from "../area";

import type {
  AreaComponents,
  AreasMethods,
  Breakpoint,
  BreakpointMethod,
  Components,
  InitAreasMethod,
} from "./areas.types";

const breakpointMethods: BreakpointMethod[] = [
  "all",
  "largeMobile",
  "smallTablet",
  "tablet",
  "smallDesktop",
  "desktop",
  "largeDesktop",
];

export const getAreaComponents = (
  Components: Components<string>,
): AreaComponents<string> => {
  const entries = Object.entries(Components).map(([name, Component]) => [
    name,
    area(Component, name),
  ]);
  return Object.fromEntries(entries);
};

export const initAreasMethods = (
  initAreasMethod: InitAreasMethod,
): AreasMethods<string> => {
  const entries = breakpointMethods.map(method => {
    const breakpoints: Breakpoint[] = [];
    breakpoints.push(method);
    return [method, initAreasMethod(breakpoints)];
  });

  return Object.fromEntries(entries);
};
